/** Employees who may apply Work From Home (option + balance card). */
export const WORK_FROM_HOME_EMPLOYEE_IDS = [
  "7ca5c597-7db9-44ae-b081-0885bae172a7",
  "01f101ac-3a98-4c36-a998-dd8dec2a014a",
  "02ee7591-ee2e-11ef-84e7-066fcdd099ff",
  "84059cb6-25d2-459c-964e-a242dee30883",
  "6c0120ea-8b24-4b0d-b6d8-d7048e710ee8",
  "269fb067-c47f-4abc-8206-5fc5b04a3ffa",
  "7afee217-41cb-4049-8a91-b590bd88fd28",
];

export function canAccessWorkFromHome(userId) {
  const id = String(userId || "").trim();
  if (!id) return false;
  return WORK_FROM_HOME_EMPLOYEE_IDS.includes(id);
}
